import React from "react";
var __jsx = React.createElement;
import stl from "./AsideHeader.module.css";
import { CDN_LINK } from "@globalConfig";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
function AsideHeader(_ref) {
  var setOpenedFilter = _ref.setOpenedFilter,
    setTempSelectedOptions = _ref.setTempSelectedOptions;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    needToShowReset = _useState[0],
    setNeedToShowReset = _useState[1];
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var location = useLocation();
  useEffect(function () {
    if (location.pathname !== "/filters" || location.search) {
      setNeedToShowReset(true);
    } else {
      setNeedToShowReset(false);
    }
  }, [location]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "AsideHeightOne",
    className: stl.container
  }, /*#__PURE__*/React.createElement("strong", {
    className: ["m-show", stl.mobileHEdingStyle].join(" "),
    onClick: function onClick() {
      document.getElementById("clickMeToCloseFilter").click();
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/arrAcc.svg",
    alt: "back",
    width: 12,
    height: 7
  }), /*#__PURE__*/React.createElement("span", null, t("فلترة النتائج", {
    ns: "web_search"
  }))), /*#__PURE__*/React.createElement("strong", {
    className: "m-hide"
  }, t("فلترة النتائج", {
    ns: "web_search"
  })), needToShowReset && /*#__PURE__*/React.createElement("span", {
    className: stl.resetData,
    onClick: function onClick() {
      setOpenedFilter(null);
      setTempSelectedOptions([]);
      navigateTo("/filters");
    }
  }, t("إعادة تعيين", {
    ns: "web_search"
  }))));
}
export default AsideHeader;